module.exports = __webpack_public_path__ + "media/referrals/MATokens-2e285fc2.png";